import Scrollbar from './scrollbar';

export default Scrollbar;



// WEBPACK FOOTER //
// ./src/index.js